import clsx from "clsx";
import { formatTime } from "../../lib/format";
import type { AutosaveStatus } from "./useAutosave";

const text: Record<AutosaveStatus, string> = {
  clean: "No changes",
  dirty: "Unsaved changes",
  saving: "Saving…",
  saved: "Saved",
  offline: "Offline: changes are kept on this device and saved when the connection returns",
  conflict: "Not saved: someone else saved a newer version",
  locked: "Not saved: someone else holds the edit lock",
  rejected: "Not saved",
};

export function SaveStatus({
  status,
  lastSavedAt,
  error = null,
}: {
  status: AutosaveStatus;
  lastSavedAt: string | null;
  error?: string | null;
}) {
  const label =
    status === "saved" && lastSavedAt
      ? `Saved at ${formatTime(lastSavedAt)}`
      : status === "rejected" && error
        ? `Not saved: ${error}`
        : text[status];
  return (
    <span
      role="status"
      className={clsx(
        "inline-flex items-center gap-1.5 text-xs",
        status === "offline" || status === "conflict" || status === "locked" || status === "rejected"
          ? "text-orange-ink"
          : "text-ink-3",
      )}
    >
      <span
        aria-hidden="true"
        className={clsx(
          "h-1.5 w-1.5 rounded-full",
          status === "saved" || status === "clean" ? "bg-green" : status === "saving" ? "bg-line-strong" : "bg-orange",
        )}
      />
      {label}
    </span>
  );
}
